export const cookieDomains = ['yousee.dk', 'nuuday.nu', 'localhost'];
